import { combineReducers } from "redux";
import { companySupportTeamStore, ICompanySupportTeamState } from "../../../Reducers/CompanySupportTeamReducer";
import { digitalShare, IDigitalShareReducer } from "../../../Reducers/DigitalShareReducer";
import { IGPSInsightsState, mobilyticsReportOutput } from "../../../Reducers/GPSInsightsReducer";
import { ILoadScoutReducerState, loadScout } from "../../../Reducers/LoadScoutReducer";
import { IReportMapState, reportMap } from "../../../Reducers/ReportMapReducer";
import { IRetailMatchState, matchReportOutput } from "../../../Reducers/RetailMatchReducer";
import { ITerritoryManagementStore, territoryManagement } from "../../../Reducers/TerritoryManagementReducer";
import { IUserManagementStore, userManagement } from "../../../Reducers/UserManagementReducer";
import { IUserPreferencesStore, userPreferencesStore } from "../../../Reducers/UserPreferencesReducer";
import { IUserProfileStore, userProfile } from "../../../Reducers/UserProfileReducer";
import { IUserReducerState as ILegacyUserReducerState, user } from "../../../Reducers/UserReducer";
import { appReducer, IAppReducerState } from "./AppReducer";
import { brandsReducer, IBrandsReducerState } from "./BrandsReducer";
import { categoriesReducer, ICategoriesReducerState } from "./CategoriesReducer";
import { commonReducer, ICommonReducerState } from "./CommonReducer";
import { ILoginReducerState, loginReducer } from "./LoginReducer";
import { IMapReducerState, mapReducer } from "./MapReducer";
import { IMobilyticsReducerState, mobilyticsReducer } from "./MobilyticsReducer";
import { INotificationsReducerState, notificationsReducer } from "./NotificationsReducer";
import { IReportsReducerState, reportsReducer } from "./ReportsReducer";
import { IRetailMatchReducerState, retailMatchReducer } from "./RetailMatchReducer";
import { ISideNavReducerState, sideNavReducer } from "./SideNavReducer";
import { ISubmitMatchFormState, submitMatchFormReducer } from "./SubmitMatchFormReducer";
import { IVoidGapReducerState, voidGapReducer } from "./VoidGapReducer";
import { IFactorState, factorReducer } from "../../../Reducers/FactorReducer";

export interface IRootReducer {
    sideNavReducer: ISideNavReducerState;
    mapReducer: IMapReducerState;
    appReducer: IAppReducerState;
    reportsReducer: IReportsReducerState;
    brandsReducer: IBrandsReducerState;
    categoriesReducer: ICategoriesReducerState;
    retailMatchReducer: IRetailMatchReducerState;
    submitMatchFormReducer: ISubmitMatchFormState;
    mobilyticsReducer: IMobilyticsReducerState;
    voidGapReducer: IVoidGapReducerState;
    loginReducer: ILoginReducerState;
    notificationsReducer: INotificationsReducerState;
    mobilyticsReportOutput: IGPSInsightsState;
    factorReducer: IFactorState;
    matchReportOutput: IRetailMatchState;
    reportMap: IReportMapState;
    loadScout: ILoadScoutReducerState;
    digitalShare: IDigitalShareReducer;
    //Legacy user reducer
    user: ILegacyUserReducerState;
    userPreferencesStore: IUserPreferencesStore;
    userManagement: IUserManagementStore;
    territoryManagement: ITerritoryManagementStore;
    companySupportTeamStore: ICompanySupportTeamState;
    userProfile: IUserProfileStore;
    commonReducer: ICommonReducerState;
}

export const rootReducer = combineReducers<IRootReducer>({
    sideNavReducer,
    mapReducer,
    appReducer,
    reportsReducer,
    brandsReducer,
    categoriesReducer,
    retailMatchReducer,
    submitMatchFormReducer,
    mobilyticsReducer,
    voidGapReducer,
    loginReducer,
    notificationsReducer,
    mobilyticsReportOutput,
    factorReducer,
    matchReportOutput,
    reportMap,
    loadScout,
    digitalShare,
    commonReducer,
    //Legacy user/user settings reducers
    user,
    userPreferencesStore,
    userManagement,
    territoryManagement,
    companySupportTeamStore,
    userProfile,
});
